import { FormItemName } from '@src/framework/workbench/drawer/constants';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import { IItems } from '../form.interface';

/**
 * 获取connector-model需要置灰的设置项。
 * @param model 所选元素
 * @returns
 */
export const getConnectorDisabledItems = (model: IConnectorModel): IItems => ({
    // TODO 连接线暂不支持锁定纵横比
    [FormItemName.SIZE_ADJUST]: () => true,
    [FormItemName.FILL_SELECT]: () => true,
});
